<h1 mat-dialog-title>Remove Contact</h1>
<div mat-dialog-content>
  Are you sure to remove <b>{{ data.record }}</b> from <b>{{ data.category }}</b> and agree to privacy terms?
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true">Remove</button>
</div>
